import React from 'react'
import * as Images from '../../../assets';

const DayTwo = ({ titleRef, isVisible, data }) => {
    return (
        <>
            <div className="flex justify-center items-center px-16 py-6 bg-[#fff8F5] max-md:px-5 relative max-xs:px-5 max-sm:py-0">

                <div className="text-start flex flex-col items-center pt-12  max-w-full w-[1296px] mx-auto xs:px-5 z-10 max-sm:pt-3 " ref={titleRef}>
                    <div
                        className={`mt-6 text-5xl font-bold leading-[58px] max-md:text-4xl  ${isVisible ? 'about-us_title_animation_fade_in_right' : ''}`}
                    >
                        <span className='text-orange-500'>DAY 2: STRATEGIC INTELLIGENCE</span> & <span className='text-orange-500'>CRISIS LEADERSHIP</span>
                    </div>


                </div>
            </div>

            <div className='flex justify-center items-center px-16 py-6 relative bg-[#fff8F5] max-md:px-5 max-xs:px-5 max-sm:py-0'>

                <img
                    loading="lazy"
                    src={Images.vector_elite1}
                    style={{ transform: "rotate(180deg)" }}
                    className="object-cover absolute bottom-0 z-0"
                    alt=''
                />

                <div className="py-7 pr-8 pl-8 mt-12 max-w-full w-[1296px] bg-white rounded-[32px]  max-lg:pr-5 max-lg:mt-10 z-10"
                    style={{ boxShadow: '0 0 10px 0 rgba(255, 115, 0, 0.25)' }}
                    ref={titleRef}
                >
                    <div className="flex flex-col md:flex-col items-center lg:flex-row gap-3">
                        <div
                            className="flex flex-col w-[59%] md:ml-0 max-lg:w-full max-lg:w-full lg:w-full md:w-full"
                        >
                            <div className="flex flex-col grow ">
                                <div
                                    className={`flex gap-5 items-center border-l-2 font-medium border-orange-500 ${isVisible ? 'animation_fadeInRight1' : ''}`}
                                >
                                    <div className="self-start text-xl text-start rounded-r-full terms_bg_clr bg-opacity-10 p-5 max-sm:text-xl w-[90%]">
                                        {/* Business{" "} */}
                                        <p className="font-bold">
                                            {/* {decodeHTML(item?.title)} */}
                                            Module <span className="text-orange-500 text-xl md:text-xl font-medium font-outline-1">03</span>
                                        </p>
                                        <p className="font-bold">
                                            {/* {decodeHTML(item?.title)} */}
                                            The <span className='text-orange-500'> 8 Triggers </span> Of <span className='text-orange-500'>Crisis</span>
                                        </p>
                                    </div>

                                </div>
                                <div className="self-stretch  max-lg:py-2">
                                    <p className='text-orange-500 font-bold my-2 text-lg'>Special Hints For Jewellary:</p>
                                    <div className='flex gap-5 max-sm:gap-0 max-sm:flex-col'>
                                        <div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            New competition format
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Technology change
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Change in shopping culture
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Economic instability
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Government regulations
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Employee life changes
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Customer Life Cycle
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-5 ">
                                                <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                                    <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                        <img
                                                            src={Images.circle}
                                                            alt=''
                                                            className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                        />
                                                        <div className="flex-auto max-lg:text-xs">
                                                            Owner Life Stages
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="self-stretch  max-lg:py-2">
                                    <p className='text-orange-500 font-bold my-2 text-lg'>You Will Get:</p>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    A framework for turning crisis into opportunity
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Early warning power
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Trigger Intelligence Matrix
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Market Immunity Strategy
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            // className="flex ml-5 w-full md:w-[41%] md:ml-0 "
                            className="flex ml-5 w-[41%] md:ml-0 max-lg:w-full max-lg:w-full lg:w-full md:w-full sm:ml-0 xs:ml-0 lg:ml-0 max-lg:ml-0"
                        >
                            <img
                                loading="lazy"
                                src={Images.day2_module3}
                                alt=''
                                // className="self-stretch my-auto w-full aspect-[1.56] rounded-2xl"
                                className="self-stretch my-auto w-full rounded-2xl"
                            />
                        </div>
                    </div>
                </div>

            </div >
            <div className='flex justify-center items-center relative px-16 py-6 bg-white max-md:px-5 max-xs:px-5 max-sm:py-0'>



                <div className="py-7 pr-8 pl-8 mt-12 max-w-full w-[1296px] bg-white rounded-[32px] relative max-lg:pr-5 max-lg:mt-10"
                    style={{ boxShadow: '0 0 10px 0 rgba(255, 115, 0, 0.25)' }}
                    ref={titleRef}
                >
                    <div className="flex flex-col md:flex-col items-center lg:flex-row gap-10">

                        <div
                            // className="flex ml-5 w-full md:w-[41%] md:ml-0 "
                            className="flex ml-5 w-[41%] md:ml-0 max-lg:w-full max-lg:w-full lg:w-full md:w-full sm:ml-0 xs:ml-0 lg:ml-0 max-lg:ml-0"
                        >
                            <img
                                loading="lazy"
                                src={Images.day2_module4}
                                alt=''
                                // className="self-stretch my-auto w-full aspect-[1.56] rounded-2xl"
                                className="self-stretch my-auto w-full rounded-2xl"
                            />
                        </div>
                        <div
                            className="flex flex-col w-[59%] md:ml-0 max-lg:w-full max-lg:w-full lg:w-full md:w-full"
                        >
                            <div className="flex flex-col grow ">
                                <div
                                    className={`flex justify-end gap-5 items-center border-r-2 font-medium border-orange-500 ${isVisible ? 'animation_fadeInRight1' : ''}`}
                                >
                                    <div className="self-start text-xl text-end rounded-l-full terms_bg_clr bg-opacity-10 p-5 max-sm:text-xl w-[90%]">
                                        {/* Business{" "} */}
                                        <p className="font-bold">
                                            {/* {decodeHTML(item?.title)} */}
                                            Module <span className="text-orange-500 text-xl md:text-xl font-medium font-outline-1">04</span>
                                        </p>
                                        <p className="font-bold">
                                            {/* {decodeHTML(item?.title)} */}
                                            <span className='text-orange-500'>3 Engines</span> Of <span className='text-orange-500'>Explosive Growth</span>
                                        </p>
                                    </div>

                                </div>
                                <div className="self-stretch  max-lg:py-2">
                                    <p className='text-orange-500 font-bold my-2 text-lg '>You will understand:</p>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Attraction Brand Trust and Aura
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Conversion Consultative Sales Skills
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    More than expected a memorable experience
                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                </div>
                                <div className="self-stretch  max-lg:py-2">
                                    <p className='text-orange-500 font-bold my-2 text-lg max-lg:text-xs'>Workshop outcome:</p>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Customer Journey Map
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Attraction analysis
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-5 ">
                                        <div className="flex flex-wrap grow text-lg text-zinc-600 w-full max-sm:text-xs">
                                            <div className="flex flex-auto w-[50%] justify-between items-center text-start py-2 max-lg:p-1">
                                                <img
                                                    src={Images.circle}
                                                    alt=''
                                                    className='my-auto rounded-full stroke-[1.9px] w-5 h-5'
                                                />
                                                <div className="flex-auto max-lg:text-xs">
                                                    Conversion script model
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </>
    )
}

export default DayTwo;
